import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteArea = ({ areaId }: { areaId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Areas/DeleteArea/${areaId}`);
};

type QueryFnType = typeof deleteArea;

type UseDeleteAreaOptions = {
  areaId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteArea = ({ config }: UseDeleteAreaOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAreas"]);
      addNotification(`Η Περιοχή Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteArea,
  });
};
